import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import DropzoneForContact from "../Contacts/DropzoneForContact";
import Images from "../../Images";
import { toast } from "react-toastify";

const UpdateStatus = ({
  updateStatusLoading,
  postUpdateStatus,
  setOpenUpdateStatusModel,
  serviceType,
  selectedData,
  userType,
}) => {
  const InitialValues = {
    id: selectedData?.id,
    status: selectedData?.status,
  };

  console.log(selectedData);

  const SubmitHandler = (values) => {
    // if (values.remarks.length == 0) {
    //   return toast.error("Please enter your remarks");
    // }
    postUpdateStatus(values);
  };

  return (
    <Model width={`w-11/12 max-w-xl `} setOpenModel={setOpenUpdateStatusModel}>
      <Title>Update Status</Title>

      {updateStatusLoading && <Loading />}

      {!updateStatusLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <InputGroup>
                <Label htmlFor="status">Status</Label>
                <FieldWrapper $select={true}>
                  <Field required name="status" id="status" autoComplete="off">
                    {(props) => (
                      <Select className="w-full h-full pl-2" {...props.field}>
                        {/* <MenuItem value="1">Pending Docs</MenuItem> */}
                        <MenuItem value="1">Active</MenuItem>
                        <MenuItem value="0">Inactive</MenuItem>
                      </Select>
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center mt-2 mb-2`;

export default UpdateStatus;
